import { BrowserRouter , Route, Routes, Navigate } from 'react-router-dom';

import LoginForm from './views/Login';
import Error404Page from './views/partial/Error404Page';
import DashboardPage from './views/Dashboard';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/styles.css'


export default function App() {
  return (
    <BrowserRouter future={{v7_startTransition: true,v7_relativeSplatPath: true}}>
      <Routes>

        <Route exact path="/" element={<LoginForm/>}/>
        {/*
        
        <Route path="/pruebas" element={<Chatbot/>}/>
        <Route path="/detalle/:sid/:type"
          element={
            <ProtectedRoute
              profile={userProfile}
              routeName='detalle'
              element={DetallesPage}
            />
          }
        />
        */}

        {/*<Route path="/" element={<Navigate to="/usuario/" replace />} />*/}
        <Route path="/dashboard/*" element={<DashboardPage/>}/>
        {/*
        <Route path="/usuario" element={<CustomerPage/>}/>
        <Route path="/usuarios" element={<CustomersPage/>}/>
        <Route path="/audiencias" element={<AudiencePage/>}/>
        */}
        <Route path="*" element={<Error404Page/>}/>
      </Routes>
    </BrowserRouter>
  );
}